// map keys is used to map a key to a value, to rename that key
// example, if your return is "prod_down" and you want to rename it to "production downtime", for a chart or legend item or color
// you would add the following to the mapKeys object { prod_down: 'production downtime' }
// this well be used when processing the api call.  the new values should match up with the keys in the colors object and icons as well 
export const mapKeys: Record<string, string> = {
  Mainten: 'maintenance',
  Prod: 'production uptime',
  Steril: 'sterilization',
  Sterilization: 'sterilization',
  Cleaning: 'cleaning',
  mainten: 'maintenance',
  Maintenance: 'maintenance',
  Sterilisation: 'sterilization',
  Waittime: 'wait time',
  Idle: 'idle',
  prod: 'production uptime',
  steril: 'sterilization',
  productionUptimeInSeconds: 'production uptime',
  productionDowntimeInSeconds: 'production downtime',
  production_downtime: 'production downtime',
  productionDowntime: 'production downtime',
  maxPossibleBottles: 'max bottles',
  approvedBottleCount: 'approved bottles',
  approved_bottle_count: 'approved bottles',
  Filling: 'filling',
  Cap: 'cap',
  'Screw Capping': 'screw capping',
  'Wait time': 'wait time',
  Availability_Rate: 'availability',
  Performance_Rate: 'performance',
  performance_rate_percentage: 'performance rate',
  performanceRatePercentage: 'performance',
  utilization_percentage: 'utilization',
  utilizationPercentage: 'utilization',
  availability_rate_percentage: 'availability',
  idlePercentage: 'idle',
  Quality_Rate: 'quality',
  'AVD Process': 'AVD',
  'Dry Air Process 121': 'Dry',
  Foil: 'foil',
  'General alarm': 'General',
  'Infeed module': 'Infeed',
  'NVD Process 125': 'NVD',
  'Outfeed module': 'Outfeed',
  'Product Circuit Process Steambarrier': 'Product',
  'General alarm and not related to any machine or process module': 'General',
  'filling': 'Filling',
  'screw capping': 'Screw',
  'N2 Flush Process': 'N2 flush',
  'loaded_not_detected_bottle_count': 'Loaded but not detected',
  'detected_not_filled_bottle_count': 'Loaded but not filled',
  'fill_level_error_bottle_count': 'Filling not complete',
  'alarm_id': 'ID',
  'alarmId': 'ID',
  'alarm_type': 'type',
  'alarmType': 'type',
  'alarm_category': 'Category',
  'alarmCategory': 'Category',
  'alarm_description': 'Description',
  'alarmDescription': 'Description',
  'alarm_class': 'Class',
  'alarmClass': 'Class',
  'runlog_id': 'Run ID',
  'runlogId': 'Run ID',
  'alarm_duration': 'Duration',
  'alarmDuration': 'Duration',
  'start_datetime': 'Start',
  'startDatetime': 'Start',
  'end_datetime': 'End',
  'endDatetime': 'End',
  'timeGroup': 'Date/Time',
  'recipeDescription': 'Recipe',
  'alarmCount': 'Count',
  'runlogDuration': 'Run Duration',
  'reject_on_cap_error_by_lane_and_row_total': 'Total Rejected',
  'reject_on_cap_error_by_lane_and_row': 'Top 10 Rejects on cap error by lane and row',
  'top_10_reject_on_cap_error_by_lane_and_slat': 'Top 10 Rejects on cap error by lane and slat',
  'top_10_reject_on_cap_error_by_lane_and_slat_total': 'Total Rejected',
  'loaded_not_detected_by_lane_and_row': 'Loaded but not detected by lane and row',
  'loaded_not_detected_by_lane_and_row_total': 'Loaded but not detected',
  'top_10_loaded_not_detected_by_lane_and_slat': 'Loaded but not detected by lane and slat',
  'top_10_loaded_not_detected_by_lane_and_slat_total': 'Loaded but not detected',
 
  
};
